import setupDeprecationWorkflow from "ember-cli-deprecation-workflow";
import DeprecationWorkflow from "./deprecation-workflow.js";

setupDeprecationWorkflow({ workflow: DeprecationWorkflow.emberWorkflowList });
